import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=76d53ba4&scoped=true&v-slot%3Aactivator=%7B%20on%2C%20attrs%20%7D"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=76d53ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d53ba4",
  null
  
)

export default component.exports